import { posthog } from 'posthog-js';

export const userEvents = {
  viewProduct: 'view_product',
  addToCart: 'add_to_cart',
  removeFromCart: 'remove_from_cart',
  updateCartQuantity: 'update_cart_quantity',
  checkout: 'checkout',
  purchase: 'purchase',
  viewFund: 'view_fund',
  viewOrganization: 'view_organization',
  viewCart: 'view_cart',
  viewHome: 'view_home',
  viewCampaignsLoadMore: 'view_campaigns_load_more',
};

export const trackEvent = (event: string, properties?: Record<string, any>) => {
  posthog.capture(event, properties);
};
